import { useEffect, useState } from 'react';

import { useThemeContext } from '../../../../contexts/ThemeContext';
import { resolveColor } from '../../theme/utils/resolveColor';
import { PoweredByQITech } from '../components/PoweredByQITech';
import * as S from './styles';

const ARTIFICIAL_LOADING_MS = 15_000;

export const PrivatePayrollAuctionCreditAnalysisReproved = () => {
    const { clientThemeSettings } = useThemeContext();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timeout = setTimeout(() => setLoading(false), ARTIFICIAL_LOADING_MS);
        return () => clearTimeout(timeout);
    }, []);

    if (!clientThemeSettings) return <></>;

    const primary = resolveColor('primary', clientThemeSettings);

    return (
        <S.PageWrapper>
            <S.LogoSection>
                {clientThemeSettings.logo_url && (
                    <S.LogoImage src={clientThemeSettings.logo_url} alt="logo" />
                )}
            </S.LogoSection>

            {loading ? (
                <S.Content>
                    <S.SpinnerWrapper>
                        <S.Spinner $color={primary} />
                    </S.SpinnerWrapper>
                    <S.Title $color={primary}>Estamos finalizando a análise da sua proposta</S.Title>
                    <S.Subtitle>Aguarde um instante enquanto concluímos</S.Subtitle>
                </S.Content>
            ) : (
                <S.Content>
                    <S.IconWrapper $color={primary}>
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="6" y1="6" x2="18" y2="18" />
                            <line x1="18" y1="6" x2="6" y2="18" />
                        </svg>
                    </S.IconWrapper>
                    <S.Title $color={primary}>Análise de crédito reprovada</S.Title>
                    <S.Subtitle>
                        Não pudemos continuar com a sua proposta neste momento. Agradecemos o seu interesse e esperamos poder atendê-lo em uma próxima oportunidade.
                    </S.Subtitle>
                </S.Content>
            )}

            <S.Footer>
                <PoweredByQITech />
            </S.Footer>
        </S.PageWrapper>
    );
};
